__turbopack_context__.v({
  "eyebrow": "ErpNextServicesCardSection-module__6oJxdq__eyebrow",
  "section": "ErpNextServicesCardSection-module__6oJxdq__section",
  "title": "ErpNextServicesCardSection-module__6oJxdq__title",
});
